import { apiGet, apiPatch, apiPost } from '../client';
import {
  BusinessStaffListResponseSchema,
  BusinessStaffRecordSchema,
  type BusinessStaffRecord,
} from '../schemas';

export function listStaff(includeInactive: boolean): Promise<{ data: BusinessStaffRecord[] }> {
  const query = includeInactive ? '?includeInactive=true' : '';
  return apiGet(`/v1/business/staff${query}`, BusinessStaffListResponseSchema);
}

export type CreateStaffInput = {
  name: string;
  role: string;
  serviceIds?: string[];
};

export function createStaff(
  input: CreateStaffInput,
  idempotencyKey: string,
): Promise<BusinessStaffRecord> {
  return apiPost('/v1/business/staff', BusinessStaffRecordSchema, input, idempotencyKey);
}

export type PatchStaffInput = {
  name?: string;
  role?: string;
  serviceIds?: string[] | null;
  isActive?: boolean;
  /** A date sends them on vacation until then; null brings them back now. */
  awayUntil?: string | null;
};

export function patchStaff(
  staffId: string,
  input: PatchStaffInput,
  idempotencyKey: string,
): Promise<BusinessStaffRecord> {
  return apiPatch(
    `/v1/business/staff/${encodeURIComponent(staffId)}`,
    BusinessStaffRecordSchema,
    input,
    idempotencyKey,
  );
}
